
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"m12.504 4.373-.005-.36a1.505 1.505 0 0 0-1.504-1.506H4.387L1.465 5.865l.031 7.124a1.505 1.505 0 0 0 1.505 1.505H11a1.505 1.505 0 0 0 1.505-1.505v-.544"}}),_c('circle',{attrs:{"cx":"6.981","cy":"9.543","r":"1.994","stroke":"#798F8F"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"m13.49 10.52 2.01-2.012m0 0-2.01-2.011m2.01 2.011h-4M9.52 5.514H4.505"}})])
          )
        }
      }
    